export default __webpack_public_path__ + "static/media/google.1e8070fe.webp";